module.exports = __webpack_public_path__ + "static/media/manila_serious.de42ba15.png";